// src/theme/collapse.ts
var collapseTheme = {
  baseStyle: "block w-full h-0 overflow-hidden data-[open=true]:h-auto data-[open=true]:overflow-visible"
};

export {
  collapseTheme
};
